module.exports = __webpack_public_path__ + "static/media/wide.b779ed3c.jpg";